import Tabs from './tabs-nav/index';

const tabs = [...document.querySelectorAll('.js-tabsnav')];

if (tabs.length > 0) {
  if (window.matchMedia("(max-width: 64rem)").matches) {
    tabs.map(
      tab => {
        tab.tabs = new Tabs(tab);
        [...tab.querySelectorAll('.crtInnerNav-link')].map(link => {
          link.classList.add('is-tab')
        })
      }
    );
  }

  window.matchMedia("(min-width: 64rem)").addListener(e => {
    if (e.matches) {
      tabs.map(tab => {
        [...tab.querySelectorAll('.crtInnerNav-link')].map(link => {
          link.classList.remove('is-tab')
        });

        if (tab.tabs) tab.tabs.remove();
        delete tab.tabs;
      })

      return
    } else {
      tabs.map(
        tab => {
          tab.tabs = new Tabs(tab);
          [...tab.querySelectorAll('.crtInnerNav-link')].map(link => {
            link.classList.add('is-tab')
          })
        }
      );
    }
  })
}
